export default function campaigns(
  state = {
    content: {},
    isLoadingCampaigns: false,
    isErred: false,
    restrictedTextingDate: null
  },
  action
) {
  switch (action.type) {
    case 'GET_CAMPAIGNS_STARTED':
      return {
        ...state,
        isLoadingCampaigns: true,
        isErred: false,
        restrictedTextingDate: null
      }

    case 'GOT_CAMPAIGNS':
      return {
        ...state,
        content: {
          ...state.content,
          [action.payload.subsidiaryId]: action.payload.items
        },
        isLoadingCampaigns: false,
        alternateReviewLink: action.payload.alternateReviewLink,
        restrictedTextingDates: action.payload.restrictedTextingDates,
        isErred: false
      }

    case 'GET_CAMPAIGNS_FAILED':
      return {
        ...state,
        isErred: true,
        isLoadingCampaigns: false
      }

    default:
      return state
  }
}
